import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import toUpper from 'lodash/toUpper';
import Button from 'components/Form/Button';
import Input from 'components/Form/Input';
import FormGroup from 'components/Form/FormGroup';
import Form from 'components/Form';
import App, { AlertsBus } from 'modules/App';
import { useAction } from 'hooks';
import * as actions from '../../actions';
import { ENROLL_IN_CLINIC_FORM } from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import validatorRules from './validatorRules.json';
const formName = ENROLL_IN_CLINIC_FORM;
const infoMessages = {
    waitForRequestAccepted: messages.infos.waitForRequestAccepted,
    provideEnrollCode: messages.infos.provideEnrollCode
};
const headerMessages = {
    waitForRequestAccepted: messages.headers.waitForRequestAccepted,
    enrollInClinic: messages.headers.enrollInClinic
};
const EnrollInClinicForm = ({ onCancel, className })=>{
    const isInProgress = useSelector(selectors.isEnrollInClinicInProgress);
    const formValues = useSelector(App.selectors.formSelector(formName));
    const enrollInClinic = useAction(actions.enrollInClinic);
    const clearForm = useAction(App.actions.clearForm, formName);
    const setFormValue = useAction(App.actions.setFormValue, formName);
    const submitForm = useCallback(({ enrollCode })=>{
        enrollInClinic(enrollCode);
    }, []);
    const processForm = App.hooks.useFormProcessing(formName, submitForm);
    const onSubmit = ()=>processForm(formValues, validatorRules);
    const onSetEnrollCode = (input)=>{
        input.value = toUpper(input.value);
        setFormValue(input);
    };
    useEffect(()=>()=>{
            clearForm();
        }, []);
    return /*#__PURE__*/ _jsxs("div", {
        className: className,
        children: [
            /*#__PURE__*/ _jsx(AlertsBus, {
                className: "mb-5",
                isGlobal: true
            }),
            /*#__PURE__*/ _jsxs(Form, {
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ _jsx(FormGroup, {
                        id: "enrollCode",
                        labelMessage: messages.labels.enrollCode,
                        formValues: formValues,
                        children: /*#__PURE__*/ _jsx(Input, {
                            placeholder: messages.placeholders.enrollCode,
                            attributes: {
                                autoFocus: true
                            },
                            onChange: onSetEnrollCode
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "modal__actions row",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-6",
                                children: /*#__PURE__*/ _jsx(Button, {
                                    styleModifier: "quaternary",
                                    labelMessage: messages.buttons.close,
                                    className: "btn--block",
                                    isDisabled: isInProgress,
                                    onClick: onCancel
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-6",
                                children: /*#__PURE__*/ _jsx(Button, {
                                    type: "submit",
                                    styleModifier: "primary",
                                    labelMessage: messages.buttons.submit,
                                    className: "btn--block btn--filled",
                                    isInProgress: isInProgress
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
// TODO: Should be in hooks
const useEnrollInClinic = (onCancel)=>{
    const isInProgress = useSelector(selectors.isEnrollInClinicInProgress);
    const isInProgressRef = useRef(isInProgress);
    const hasErrors = useSelector(selectors.hasEnrollInClinicErrors);
    const [isSucceed, setIsSucceed] = useState(false);
    useEffect(()=>{
        if (isInProgressRef.current && !isInProgress) {
            if (!hasErrors) {
                setIsSucceed(true);
            }
        }
        isInProgressRef.current = isInProgress;
    }, [
        isInProgress
    ]);
    const renderEnrollInClinicForm = (className)=>/*#__PURE__*/ _jsx(EnrollInClinicForm, {
            onCancel: onCancel,
            className: className
        });
    return {
        isSucceed,
        setIsSucceed,
        infoMessages,
        headerMessages,
        renderEnrollInClinicForm: (className)=>renderEnrollInClinicForm(className)
    };
};
export default useEnrollInClinic;
